import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { ContentSlotComponent } from 'ish-shared/cms/components/content-slot/content-slot.component';
import { CMSComponent } from 'ish-shared/cms/models/cms-component/cms-component.model';

/**
 * The CMS Standard Page Component to render CMS content of the 'Standard Page' page variant model.
 * Note: For the PWA the it only renders the content of the 'content' slot.
 * The 'header' and 'footer' slot content is not rendered.
 */
@Component({
  selector: 'ish-cms-standard-page',
  templateUrl: './cms-standard-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ContentSlotComponent],
})
export class CMSStandardPageComponent implements CMSComponent {
  readonly pagelet = input<ContentPageletView>(undefined);
}
